<div *ngIf="node.data.displayVal; else labelOnly">
  <div *ngIf="valDisplayType === 'text' || valDisplayType === 'checkbox';">
    <app-tree-row-value [valDisplayType]="valDisplayType" [node]="node" [value]="value" [timestamp]="timestamp"
      (eventTriggered)="checkboxActionTriggered($event)">
    </app-tree-row-value>
  </div>
  <div *ngIf="valDisplayType === 'table'">
    <table class="datset-table">
      <tr>
        <th *ngFor="let column of value.columnNames">{{column}}</th>
      </tr>
      <tr *ngFor="let data of value.values">
        <td *ngFor="let column of value.columnNames">
          <ng-container>
            <div *ngIf="(data[column] === 'true' || data[column] === 'false'); else textField">
              <mat-checkbox [checked]="data[column]" color="primary" class="checkbox" style="pointer-events: none;"></mat-checkbox>
            </div>
            <ng-template #textField>
              <span *ngIf="!(data[column] ==='true' || data[column] =='false') "> {{data[column]}} </span>
            </ng-template>
          </ng-container>
        </td>
      </tr>
    </table>
  </div>

  <ng-template #checkboxDisplay>
    <div style="justify-content: space-between; display: flex">
      <b style="padding-top: 2px">{{ node.label }}</b>

      <mat-checkbox disabled color="primary" [checked]="value === 'true' || node.data.displayVal['value'] === 'true'">
      </mat-checkbox>
    </div>
  </ng-template>
</div>

<ng-template #labelOnly>
  <b>{{ node.label }}</b>
</ng-template>